// extracted by mini-css-extract-plugin
export default {"imgdiv":"b965b75190 f509af335b","img":"_96ba5cf56e bdbca00f0a"};